// Editor transforms behind the block handle menu. Each resolves the block's
// path FRESH via editor.api.findPath at call time — caching a path goes stale
// once content above the block is edited (the same lesson the table row/column
// handles learned: a cached path silently no-ops or hits the wrong node).
//
// These mirror the transforms already used elsewhere in the editor: the slash
// menu inserts nodes via tf.insertNodes, the table handles remove/move via
// tf.removeNodes / tf.moveNodes, and tf.duplicateNodes is Plate's built-in
// block-duplication transform.

function resolvePath(editor: any, element: any): number[] | null {
    try {
        const path = editor?.api?.findPath?.(element);
        return Array.isArray(path) ? path : null;
    } catch {
        return null;
    }
}

/** Insert an empty paragraph immediately after this block and place the caret in it. */
export function insertParagraphBelow(editor: any, element: any): void {
    const path = resolvePath(editor, element);
    if (!path) return;
    const at = [...path.slice(0, -1), path[path.length - 1] + 1];
    editor?.tf?.insertNodes?.({ type: 'p', children: [{ text: '' }] }, { at, select: true });
    editor?.tf?.focus?.();
}

/**
 * Duplicate this block directly below itself. Uses Plate's tf.duplicateNodes,
 * which clones the node (assigning a fresh id via NodeIdPlugin's normalizer on
 * the next pass) and inserts it as the next sibling.
 */
export function duplicateBlock(editor: any, element: any): void {
    const path = resolvePath(editor, element);
    if (!path) return;
    // `block: true` is required — tf.duplicateNodes no-ops without it (it needs
    // either explicit `nodes` or `block: true` to resolve the block(s) at `at`).
    editor?.tf?.duplicateNodes?.({ at: path, block: true });
    editor?.tf?.focus?.();
}

/** Remove this block from the document. */
export function removeBlock(editor: any, element: any): void {
    const path = resolvePath(editor, element);
    if (!path) return;
    editor?.tf?.removeNodes?.({ at: path });
    editor?.tf?.focus?.();
}
